import type { Ivr } from '@/apis/generated/dialpad-contact';
import { apiStoreFactory } from '@/api-store-factory';
import type { StoreEntity } from '@/api-store-factory';
import { STORE } from '@/store-ids';
import { IvrFromJSON } from '@/apis/generated/dialpad-contact';

export type IvrStore = StoreEntity<Ivr, 'id', {}>;

export const useIvrStore = apiStoreFactory<
  IvrStore['entity'],
  IvrStore['id'],
  IvrStore['filter'],
  IvrStore['createInput'],
  IvrStore['updateInput']
>(
  STORE.IVR,
  { entityIdKey: 'id', supportPagination: false },
  {
    read: async (ivrId, { contactApi }) => {
      return await contactApi.getCustomIvr({
        ivrId,
      });
    },

    bulkRead: async (ivrIds: string[], { contactApi }) => {
      ivrIds = ivrIds.map((ivrId) => `CustomIvr:${ivrId}`);
      const customIvrs = await contactApi.getModelsByKeys({
        keys: ivrIds.join(','),
        projection: '',
        extended: true,
        excludeSoftDeleted: false,
      });
      return customIvrs.map(IvrFromJSON);
    },
  },
);
